import { FC } from "react";
import styled, { css } from "styled-components";

import { Card } from "@/components/Metrics/TrendCard";

const StyledCard = styled(Card)`
  display: flex;
  align-items: center;
  justify-content: center;
  ${({ theme }) => css`
    a {
      color: ${theme.colors.lightGray};
      &:hover {
        color: ${theme.colors.purple};
      }
    }
    circle {
      color: ${theme.colors.grayscale};
    }
  `}
`;

const LinkCard: FC = () => {
  return (
    <StyledCard>
      <a
        href="https://surveys.hotjar.com/13dd9598-77c9-4013-90ec-ce073873adcd"
        target="_blank"
        rel="noreferrer noopener"
      >
        <svg
          width="56"
          height="56"
          viewBox="0 0 56 56"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M28 20V36"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M20 28H36"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle
            cx="28"
            cy="28"
            r="27.75"
            stroke="currentColor"
            strokeWidth="0.5"
          />
        </svg>
      </a>
    </StyledCard>
  );
};

export default LinkCard;
